import Vuex from 'vuex';
import Vue from 'vue';
import theory from './modules/theory';

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    theory,
  },
});
